export function storeKeyName(key: string): string
{
    return key.replaceAll("/", "|");
}

export function lookupKeyName(key: string): string
{
    return key.replaceAll("|", "/");
}